// BASIC STARTER REQUIREMENTS
var lazy = require('./vendor/jquery.lazy.js')
require('./vendor/skip-link-focus-fix.js')
require('babel-polyfill')
//require('foundation-sites')


// ADDITIONAL 3RD PARTY REQUIREMENTS
// var slick 			= require('./vendor/slick.js');
// var _ 				= require('underscore');
// var moment 			= require('moment');
// var foundation 		= require('foundation-sites'); // Requires: npm install foundation-sites

// Get Viewport Dimensions
function updateViewportDimensions() {
    var w=window,d=document,e=d.documentElement,g=d.getElementsByTagName('body')[0],x=w.innerWidth||e.clientWidth||g.clientWidth,y=w.innerHeight||e.clientHeight||g.clientHeight;
    return { width:x,height:y };
}

function isInternetExplorer () {
    return !!( navigator.userAgent.match(/Trident/) && !navigator.userAgent.match(/MSIE/) );
}

// setting the viewport width
var viewport = updateViewportDimensions();

// David Walsh Debounce
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    }
}

// Throttle from underscore 1.8.3
function throttle (func, wait, options) {
    var context, args, result
    var timeout = null
    var previous = 0
    if (!options) options = {}
    var later = function () {
        previous = options.leading === false ? 0 : Date.now()
        timeout = null
        result = func.apply(context, args)
        if (!timeout) context = args = null
    }
    return function () {
        var now = Date.now()
        if (!previous && options.leading === false) previous = now
        var remaining = wait - (now - previous)
        context = this
        args = arguments
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout)
                timeout = null
            }
            previous = now
            result = func.apply(context, args)
            if (!timeout) context = args = null
        } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining)
        }
        return result
    }
}

// Braid Namespace
var braid = braid || {};

// utilities
braid.query = function(selector) {
    return document.querySelector(selector);
};

braid.isHome = !!document.getElementsByClassName('home').length;
braid.isFlexible = !!document.getElementsByClassName('page-template-page-flexible').length;
braid.hasForm = !!document.getElementsByClassName('gform_wrapper').length;
braid.header = document.getElementById("masthead");
braid.content = document.getElementById("content");
braid.menu = document.getElementById("site-navigation");
braid.page = document.getElementById("page");
braid.mobileBreakpoint = 680;



// Set up namespace
var braidStarter = braidStarter || {};


function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}



(function(ns, $win, $, undefined) {
    var $htmlBody = $('html, body');

    $(document).foundation();


    function affixElement(el) {
        var scrollTop = $(window).scrollTop(),
            that_top = el.data('top') ? $(el.data('top')).offset().top : 0,
            that_btm = el.data('bottom') ? $(el.data('bottom')).outerHeight(true) + $(el.data('bottom')).offset().top : 0;
        
        if(scrollTop < that_top) {
          el.scrollTop(0);
          el.addClass('affix-top').removeClass('affix-bottom').removeClass('affix-fix');
          console.log('top');
        } else if((scrollTop + el.outerHeight(true)) > that_btm && that_btm > 0) {
          console.log('bottom');
          el.scrollTop(el.height());
          el.removeClass('affix-top').addClass('affix-bottom').removeClass('affix-fix');
        } else {
          console.log('fix');
          el.removeClass('affix-top').removeClass('affix-bottom').addClass('affix-fix');
        }
      }

      $('.affix').each(function(){
        var that = $(this);
        affixElement(that);

        $(window).on('scroll', function(){
          affixElement(that);
        });

      });

          


    if($('.first-time-overlay').length > 0) {

      if( getCookie('newsletterPageCount' ) === '') {

        console.log('no cookie');

        setCookie('newsletterPageCount','1',3);

      }

      else if ( getCookie('newsletterPageCount' ) === '1') {
        //$('.first-time-overlay').delay(1000).fadeIn();
        console.log('second page visit');
        $('.first-time-overlay').delay(2000).fadeIn();
        setCookie('newsletterPageCount','2',3);
      }

      else {
        console.log('no cookie at all');
      }
      
      $('.first-time-overlay .close-button, #first-time-overlay__bg').on('click',function(){

          $('.first-time-overlay').fadeOut();
          // $('body').removeClass('locked');

      });
      
    }

    // $('.first-time-overlay').fadeIn();

    // http://jquery.eisbehr.de/lazy/
    // usage <img class="lazy" data-src="/some-path" alt=""> for img
    // usage <div class="lazy" data-src="/some-path" alt=""> for background image
    function initLazyLoad() {
        $('.lazy').lazy({
            effect: "fadeIn",
            effectTime: 500,
            threshold: 500
        });
    }

    function addIeClassToBody () {
        if( isInternetExplorer() ) {
            $('body').addClass('internet-explorer');
        }
    }

    function toggleNavMenu() {
        $('#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4').click(function() {
            $(this).toggleClass('open');
            $(braid.menu).slideToggle();
        });
    }

    function smoothScroll() {
        var $links = $('.smooth-scroll');

        $links.click(function(e){
            e.preventDefault();
            var $this = $(this);
            var $target = $($this.attr('href'));
            $htmlBody.animate({scrollTop: $target.offset().top}, '500', 'swing');
        });
    }

    function contentAccordion() {
        $('.content-accordion').on('click', '.content-accordion--btn', function() {
            var $btn = $(this);
            var $container = $btn.closest('.content-accordion');
            var $content = $container.find('.content-accordion--hidden');
            $content.slideToggle(function(){
                $content.is(':visible') ? $btn.text('See Less') : $btn.text('See More');;
            });
        });
    }

    function initToggle() {
        var $toggleItem = $('.js-toggle');
        $toggleItem.click(function() {
            $(this).toggleClass('active');
        });
    }

    function handlePrintPage() {
        var $printButton = $('#js-print');
        $printButton.click(function() {
            window.print();
        });
    }




    $('body').on('click', '.js-show-popup-bubble, .js-show-popup-bubble-test', function(){
        if ( $(this).closest('h5').length ) {
            $(this).closest('h5').find('.table-header-popup').fadeIn(300);
        }
        else if ( $(this).closest('li').length ) {
            $(this).closest('li').find('.table-header-popup').fadeIn(300);
        }
            
    });

    $('body').on('click', '.js-hide-popup-bubble', function(){
        
        if ( $(this).closest('h5').length ) {
            $(this).closest('h5').find('.table-header-popup').fadeOut(150);
        }
        else if ( $(this).closest('li').length ) {
            $(this).closest('li').find('.table-header-popup').fadeOut(150);
        }
    });


    $( "#units-accordion" ).accordion({
        header: "h3",
        collapsible: true,
        active: false,
        heightStyle: 'content'
    });



    





    // ----
    // public methods and variables
    // ----
    ns.init = function() {
        toggleNavMenu();
        smoothScroll();
        initLazyLoad();
        contentAccordion();
        addIeClassToBody();
        initToggle();
        handlePrintPage();
    };

    ns.windowLoadInit = function() {
    };


    $('body.home').on('click', '.display-more', function(){


        if ( $(this).hasClass('full-view') ) {
            $(this).text('display more');
            $('#current-members-view').removeClass('full-view');
            $(this).removeClass('full-view');
        }
        else {
            $(this).text('display less');
            $('#current-members-view').addClass('full-view');
            $(this).addClass('full-view');
        }

        

    });


    $('body.page-template-page-resources').on('click', '.site-main .row > a', function(){

        var test = $(this).find('h2').text();
        console.log(test);

        ga('send', {
          hitType: 'event',
          eventCategory: 'Resource Category Grid',
          eventAction: 'click',
          eventLabel: $(this).find('h2').text(),
          transport: 'beacon'
        });

        

    });


    $('body').on('click', '.pretreatment__filterLink .pretreatment__arrow', function(){

        var popup = $(this).closest('.pretreatment__filter').find('.filter-col-wrap').show();

    });

    $('body').on('click', '.filter-col-wrap .js-hide-popup-bubble', function(){

        var popup = $(this).closest('.filter-col-wrap').hide();

    });


    $('body').on('click', '.person p, .person img', function(){
        $(this).closest('.person').find('.person-popup').fadeIn(200);
        $(this).closest('.person').find('.person-popup-bg').fadeIn(100);
    });


    $('body').on('click', '.person-popup-bg, .js-hide-person-popup', function(){
        $(this).closest('.person').find('.person-popup').fadeOut(100);
        $(this).closest('.person').find('.person-popup-bg').fadeOut(200);
    });









    


    



}(braidStarter = braidStarter || {}, jQuery(window), jQuery));







jQuery(document).ready(function($) {
    braidStarter.init();
});

// jQuery(window).load(function() {
//     // braidStarter.windowLoadInit();
// });